<template>
	<div v-if="current.status != 'win' && current.status != 'lose' && game.player.hero.bag" class="box inventory">
		<p v-show="game.player.hero.bag.length" class="title">{{ l.inventory }}</p>

		<div class="resources">
			<div class="resource">
				{{ game.player.hero.gold }}<span class="icon"></span>
				<transition-group name="gold" tag="div" class="gold-animation">
					<div v-for="gold in animation.golds" :key="gold.id" :style="{ transform: 'translate(' + gold.x + 'px, ' + gold.y + 'px)' }" class="gold"></div>
				</transition-group>
			</div>
		</div>
		
		<div class="inventory-content" ref="inventory">
			<div class="scroll-wrap">
				<div class="scroll" v-bar>
					<div class="scroll-content">
						<div v-if="game.player.hero.bag.length" class="items">
							<item
								v-for="item in items"
								:key="item.card.slug"
								:item="item"
								@mouseenter.native="enter_hover(item)"
								@mouseleave.native="leave_hover()"

							/>
						</div>
					</div>
				</div>
			</div>
		</div>
			

	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import Item from '@/components/game/inventory/item'

export default {
	name: 'inventory',
	data: function() {
		return {
			inventory_height: 'auto',
			animation: {
				golds: []
			}
		}
	},
	computed: Object.assign(mapGetters([ 'l', 'lang', 'game', 'current' ]), {
		items: function() {
			var temp = {}

			for (var i in this.game.player.hero.bag) {
				var card = this.game.player.hero.bag[i]
				if (temp[card.slug]) {
					temp[card.slug].nb += 1
				} else
					temp[card.slug] = { card: card, nb: 1 }
			}

			return temp
		},
	}),
	watch: {
		'game.player.hero.bag': function(newValue, oldValue) {
			var h = 712 - 8 - 32
			var h = 450
			// this.$nextTick(function() {
				if (this.$refs.inventory && this.$refs.inventory.offsetHeight < h) this.inventory_height = 'auto'
				else this.inventory_height = h + 'px'
			// })
		},
		'game.player.hero.gold': function(newValue, oldValue) {
			var n = newValue - oldValue
			if (n > 0) {
				var self = this
				for (var i = 0; i < n; i++) {
					var gold = { id: _.uniqueId('gold-'), x: _.random(-16, 16), y: _.random(-64, -48) }
					var index = this.animation.golds.push(gold)
				}
				setTimeout(function() {
					self.$set(self.animation, 'golds', [])
				}, 100)
				Sounds.play('coins')
			}
		}
	},
	methods: {
		enter_hover: function(item) {
			this.$store.commit('SET_HOVER_CARD', { card: item.card })
		},
		leave_hover: function() {
			this.$store.commit('SET_HOVER_CARD', { card: false })
		},
	},
	components: { Item }
}
</script>

<style lang="stylus">
@import '../../assets/css/app'

.inventory
	position absolute
	left 0
	bottom 8px
	color light
	.title
		position absolute
		left 0
		top -24px
		color light
		line-height 24px
	.resources
		position absolute
		right 0
		top -24px
		height 24px
		font-size 2.4rem
		line-height (@height - 2px)
		.resource
			display inline-block
			.icon
				display inline-block
				width 16px
				height 16px
				top 0
				margin 0 0 0 4px
				background url(../../assets/img/ui/icons.png) (-16px * 3) 0 no-repeat
				background-size auto 32px
			.gold-animation
				position absolute
				right 4px
				bottom 7px
				width 8px
				height 8px
				.gold
					position absolute
					left 0
					bottom 0
					width 100%
					height 100%
					background url(../../assets/img/ui/icons.png) (-8px * 3) 0 no-repeat
					background-size auto 16px
					transition 0.25s easeOutQuart
					&.gold-enter-to
						transition 0.1s easeOutQuart
					&.gold-enter
						opacity 0
					&.gold-leave-to
						transform translate(0, 0) !important
						opacity 0
						for i in 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15
							&:nth-child({i})
								transition-delay unit((i/50), 's')
	.inventory-content
		// height 400px
		border 2px solid light
		background-color darken(dark, 10%)
		.scroll
			max-height 500px
		.items
			padding 8px
			display flex
			flex-direction column-reverse
		

</style>
